export const AEU_BLOCKED_WIDGETS = [
    'productAreasOverviewChart',
    'productAreasList',
    'appHealthTable',
    'objectAnalyticsKeyMetrics',
    'objectAnalyticsChart',
    'timeToNth',
    'captureOnSdkVersion',
];

export const AEU_ANALYTICS_BLOCKED_WIDGETS = [
    'accountFrequency',
    'accountOverview',
    'appUsage',
    'appVersion',
    'browserUsageChart',
    'customReportChart',
    'deviceUsage',
    'embedIframeCode',
    'featureAdoption',
    'featureOverview',
    'featureUseByAccount',
    'featureUseByVisitor',
    'featuresTargeting',
    'funnelReportChart',
    'goalProgress',
    'guidesTargeting',
    'osVersion',
    'osChart',
    'pageOverview',
    'pageUseByAccount',
    'pageUseByVisitor',
    'pageFeatureUseOverTime',
    'pesTrending',
    'productEngagementScore',
    'retentionReportChart',
    'retentionByUsage',
    'stickinessMetric',
    'surveyResponsesTable',
    'timeToFirstUse',
    'topAccounts',
    'topVisitors',
    'totalTimeOnAppPerWeek',
    'trackEventUseByAccount',
    'trackEventUseByVisitor',
    'trackEventKeyMetrics',
    'trackEventChart',
    'weeklyAccounts',
];
